"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const react_native_1 = require("react-native");
const Breakpoints_1 = require("../../../../../helper/Breakpoints");
exports.styles = react_native_1.StyleSheet.create({
    rectanglePremium: {
        borderWidth: 4,
        borderColor: '#3db384',
        width: 350,
        height: 'auto',
        backgroundColor: '#3db384',
        alignItems: 'center',
        textAlign: 'center',
        padding: 5,
        marginVertical: 5,
        shadowRadius: 5,
        shadowOpacity: 0.2,
    },
    pharmacyDescription: {
        textAlign: 'center',
        lineHeight: 20,
        margin: 5,
        marginBottom: 20,
        color: 'white',
        fontSize: 13,
    },
    ratingRow: {
        flexDirection: 'row',
        width: 320,
        color: '#e3e3e3',
        marginVertical: 5,
    },
    detailsLine: {
        borderTopColor: '#e3e3e3',
        borderTopWidth: 1,
        width: '98%',
        marginVertical: 10,
    },
    divider: {
        flexDirection: 'row',
        justifyContent: 'center',
        borderTopColor: '#e0e0e0',
        borderBottomColor: '#e0e0e0',
        borderBottomWidth: 1,
        borderTopWidth: 1,
        borderRadius: 0,
        marginBottom: 10,
        marginTop: 5,
        padding: 5,
        width: 320,
        paddingVertical: 15,
        marginVertical: 15,
    },
    starsStyles: {
        position: 'absolute',
        right: -5,
        marginVertical: 1,
    },
    starStyles: {
        marginHorizontal: 0.8,
    },
    premiumText: {
        color: '#e3e3e3',
        marginVertical: -2,
        fontSize: 13.5,
    },
    imageStyle: {
        marginVertical: 15,
        flex: 1,
        resizeMode: 'contain',
        tintColor: '#fff',
    },
    buttonTextGreen: {
        fontSize: 12,
        lineHeight: 21,
        letterSpacing: 0.25,
        color: '#fff',
    },
    buttonTextWhite: {
        fontSize: 12,
        lineHeight: 21,
        letterSpacing: 0.25,
        color: '#3db384',
    },
    buttonTextWhiteDisabled: {
        fontSize: 12,
        lineHeight: 21,
        letterSpacing: 0.25,
        color: 'white',
    },
    buttonGreen: {
        alignItems: 'center',
        backgroundColor: 'transparent',
        paddingVertical: 8,
        paddingHorizontal: 20,
        marginHorizontal: 15,
        marginVertical: 10,
        marginLeft: 50,
        borderRadius: 25,
        alignSelf: !Breakpoints_1.isMobileOrTablet ? undefined : 'center',
        width: !Breakpoints_1.isMobileOrTablet ? 'fit-content' : undefined,
        overflow: 'hidden',
        borderColor: '#fff',
        borderWidth: 1,
        borderStyle: 'solid',
    },
    buttonWhite: {
        alignItems: 'center',
        backgroundColor: '#fff',
        paddingVertical: 8,
        paddingHorizontal: 20,
        marginHorizontal: 15,
        marginVertical: 10,
        borderRadius: 25,
        marginRight: 50,
        alignSelf: react_native_1.Platform.OS === 'web' ? undefined : 'center',
        width: react_native_1.Platform.OS === 'web' ? 'fit-content' : undefined,
        overflow: 'hidden',
    },
    buttonWhiteDisabled: {
        alignItems: 'center',
        backgroundColor: '#c1c1c1',
        paddingVertical: 8,
        paddingHorizontal: 30,
        marginHorizontal: 15,
        marginVertical: 10,
        borderRadius: 25,
        marginRight: 50,
        alignSelf: react_native_1.Platform.OS === 'web' ? undefined : 'center',
        width: react_native_1.Platform.OS === 'web' ? 'fit-content' : undefined,
        overflow: 'hidden',
    },
});
